import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ToolContext } from "shared-ui-components/fluent/hoc/fluentToolWrapper";
import { useSetting } from "../hooks/settingsHooks";
import { CompactModeSettingDescriptor, DisableCopySettingDescriptor } from "../services/globalSettings";
export const UXContextProvider = (props) => {
    const [compactMode] = useSetting(CompactModeSettingDescriptor);
    const [disableCopy] = useSetting(DisableCopySettingDescriptor);
    const toolsContext = useMemo(() => {
        return {
            toolName: "",
            size: compactMode ? "small" : "medium",
            disableCopy,
            useFluent: true,
        };
    }, [compactMode, disableCopy]);
    return _jsx(ToolContext.Provider, { value: toolsContext, children: props.children });
};
//# sourceMappingURL=uxContextProvider.js.map